var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.509,
    height: 20.522,
    viewBox: "0 0 20.509 20.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2822",
    "data-name": "Group 2822",
    transform: "translate(-6.778 -6.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(7.528 7.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2811",
    "data-name": "Group 2811",
    transform: "translate(-7.413 -7.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2818",
    "data-name": "Group 2818",
    transform: "translate(7.413 7.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2817",
    "data-name": "Group 2817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2815",
    "data-name": "Group 2815",
    transform: "translate(9.826 7.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15724",
    "data-name": "Path 15724",
    d: "M34.057,25.149l2.271,3.673L38.6,25.149Z",
    transform: "translate(-34.057 -25.149)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15725",
    "data-name": "Path 15725",
    d: "M26.531,16.616c-.566,2.65-1.56,4.407-2.692,4.407-1.762,0-3.19-4.258-3.19-9.511S22.076,2,23.838,2c1.611,0,2.943,3.56,3.16,8.185",
    transform: "translate(-14.932 -2)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15726",
    "data-name": "Path 15726",
    d: "M29.214,28.469c.381.017.769.025,1.163.025,5.249,0,9.5-1.529,9.5-3.415,0-1.088-1.416-2.057-3.623-2.682",
    transform: "translate(-20.872 -16.145)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15727",
    "data-name": "Path 15727",
    d: "M4.723,23.343C3.039,23.959,2,24.8,2,25.735s1.5,2.177,3.389,2.673",
    transform: "translate(-2 -16.801)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2816",
    "data-name": "Group 2816",
    transform: "translate(0.765 4.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15728",
    "data-name": "Path 15728",
    d: "M6.365,22.4l2.412-3.582-4.282-.556Z",
    transform: "translate(-4.494 -18.261)",
    fill: "#fff"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.c8b50e80c8345c1339cade5f8f318b7a.svg";
export { ForwardRef as ReactComponent };